import React from 'react'
import Button from '../components/Button'
import Container from '../components/Container'
import Hero from '../components/Hero'
import ImageContainer from '../components/ImageContainer'
import { data } from './data'

function Heading({ text = "", align = "", color = "" }) {
    return (
        <div className={`text-xl md:text-[2.5rem] md:leading-[5rem] xl:text-[3.75rem] 3xl:text-[5rem] font-bold mt-7 font-manrope ${align} ${color}`}>{text}</div>
    )
}

function SubHeading({ text = "", align = "", color = "" }) {
    return (
        <div className={`text-sm md:text-2xl xl:text-[1.75rem] 3xl:text-4xl 3xl:leading-normal font-semibold mt-2 mx-auto font-poppins ${align} ${color}`}>{text}</div>
    )
}

function Description({ text = "", align = "", color = "" }) {
    return (
        <div className={`text-xs md:text-base xl:text-[1.375rem] 3xl:text-[2rem] 3xl:leading-normal xl:leading-8 font-normal md:font-light mx-auto mt-3 font-poppins ${align} ${color}`}>{text}</div>
    )
}

function Portfolio() {

    const [width, setWidth] = React.useState(window.innerWidth)

    const handleWindowChange = () => {
        setWidth(window.innerWidth)
    }

    React.useEffect(() => {
        window.addEventListener("resize", handleWindowChange)
        return () => {
            window.removeEventListener("resize", handleWindowChange)
        };
    }, [])

    return (
        <div>
            <Hero type={'other'}>Portfolio</Hero>

            {/* Project List */}
            <div className="text-white">
                {
                    data.map((item, idx) => (
                        <div className={`${item.background}`}>
                            <Container background='py-10 md:py-16 3xl:py-28 px-5 md:grid md:grid-cols-7 3xl:grid-cols-5 place-items-center gap-4 xl:gap-0 3xl:gap-16'>
                                <div className={`md:col-span-3 3xl:col-span-2 md:h-full w-full ${idx % 2 === 0 ? 'md:order-1' : ''}`}>
                                    <ImageContainer source={item.image} alt={item.alt} height={item.imageHeight} />
                                </div>
                                <div className={`md:col-span-4 3xl:col-span-3 max-w-sm md:max-w-lg xl:max-w-xl 2xl:max-w-2xl 3xl:max-w-3xl mx-auto text-center 3xl:flex 3xl:flex-col 3xl:justify-between 3xl:space-y-10 h-full ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`}>
                                    <div className="3xl:space-y-8">
                                        <Heading text={item.title} color={item.titleColor} />
                                        <SubHeading text={item.subtitle} color={item.subTitleColor} />
                                        <Description text={item.description} color={item.textColor} />
                                    </div>
                                    <div className="hidden 3xl:block">
                                        <Button className={`${item.buttonTextColor} ${item.ringColor ? item.ringColor : '!bg-white'}`} borderClass={item.ringColor ? item.ringColor + " !bg-transparent" : '!ring-white'}>View Detailed Case Study</Button>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Portfolio
